/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { baseURL } from "utils/api";
import axios from "axios";
import { useState, useEffect } from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Button from "../../components/ButtonUse.jsx";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import placeholder from "../../assets/images/placeholder.png";

// Data

// Dashboard components

function EditShop() {
  // const location = useLocation()
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    venderId: "",
    companyName: "",
    sid: "",
    goodsAddress: "",
  });

  // useEffect(() => {
  //   async function fetchCategory() {
  //     try {

  //       const { data } = await axios.get(`${baseURL}/admin/fetch/store/${location.state}`);

  //       setFormState({
  //         ...formState,
  //         venderId: data?.store?.venderId,
  //         companyName: data?.store?.companyName,
  //         sid: data?.store?.sid,
  //         goodsAddress: data?.store?.goodsAddress

  //       });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  //   fetchCategory();
  // }, []);

  const { id } = useParams();
  const [storeData, setStoreData] = useState(null);

  const location = useLocation();

  const fetchData = async (id) => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/store/getStore/${id}`;
      const response = await axios.get(apiUrl);
      const data = response.data;
      setStoreData(data.store);
    } catch (error) {
      console.error("Error fetching store data:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  // -----------------------------PUT API------------------------------//

  // async function handleUpdateCategory(e) {
  //   e.preventDefault();

  //   try {
  //     const res = await axios.post(
  //       `${baseURL}/admin/update/store/${location.state}`,
  //       {
  //         ...formState,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (res.status === 200) {
  //       navigate("/Shops");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert("Error updating category");
  //   }
  // }
  const [file, setFile] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [venderId, setVenderId] = useState("");
  const [sid, setSid] = useState("");
  const [goodsAddress, setGoodsAddress] = useState("");
  const [rating, setRating] = useState("");
  const [subscribers, setSubscribers] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const area = {
      file,
      companyName,
      sid,
      venderId,
      goodsAddress,
      rating,
      subscribers,
    };

    // console.log(f)
    try {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(storeData),
      };
      console.log(storeData);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/store/updateStore/${id}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }
      const data = await response.json();
      console.log(data);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Data has been updated successfully!",
      });
      setFile("");
      setCompanyName("");
      setSid("");
      setVenderId("");
      setGoodsAddress("");
      setRating("");
      setSubscribers("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "An error occurred while updating data",
      });
    }
  };

  const handleRemoveImage = () => {
    setStoreData({ ...storeData, storeImage: null });
  };

  // const [imagePaths, setImagePaths] = useState([]);
  // useEffect(() => {
  //   setImagePaths();
  // },[])

  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          // onSubmit={handleUpdateCategory}
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              {storeData && (
                <div>
                  <TextField
                    id="outlined-basic"
                    sx={{ width: "20vw" }}
                    label="Veondor ID*"
                    variant="outlined"
                    value={storeData.venderId}
                    onChange={(e) => setStoreData({ ...storeData, venderId: e.target.value })}
                  />
                </div>
              )}

              {storeData && (
                <div>
                  <TextField
                    id="outlined-basic"
                    sx={{ width: "20vw" }}
                    label="Company Name*"
                    variant="outlined"
                    value={storeData.companyName}
                    onChange={(e) => setStoreData({ ...storeData, companyName: e.target.value })}
                  />
                </div>
              )}

              {storeData && (
                <div>
                  <TextField
                    id="outlined-basic"
                    sx={{ width: "20vw" }}
                    label="SID Value*"
                    variant="outlined"
                    value={storeData.sid}
                    onChange={(e) => setStoreData({ ...storeData, sid: e.target.value })}
                  />
                </div>
              )}
            </div>

            <div style={{ marginTop: "10vh" }}>
              <div style={{ display: "flex", gap: "40px" }}>
                {storeData && (
                  <div>
                    <TextField
                      id="outlined-basic"
                      sx={{ width: "20vw" }}
                      label="Good Address*"
                      variant="outlined"
                      value={storeData.goodsAddress}
                      onChange={(e) => setStoreData({ ...storeData, goodsAddress: e.target.value })}
                    />
                  </div>
                )}

                {storeData && (
                  <div>
                    <TextField
                      id="outlined-basic"
                      sx={{ width: "20vw" }}
                      label="Rating*"
                      variant="outlined"
                      value={storeData.rating}
                      onChange={(e) => setStoreData({ ...storeData, rating: e.target.value })}
                    />
                  </div>
                )}

                {storeData && (
                  <div>
                    <TextField
                      id="outlined-basic"
                      sx={{ width: "20vw" }}
                      label="No. of Subscribers*"
                      variant="outlined"
                      value={storeData.subscribers}
                      onChange={(e) => setStoreData({ ...storeData, subscribers: e.target.value })}
                    />
                  </div>
                )}
              </div>

              <div style={{ marginTop: "1%" }}>
                {storeData && (
                  <div>
                    <div className="flex flex-col mt-4 gap-4">
                      <div className="flex flex-row flex-wrap gap-3">
                        {storeData.storeImage && (
                          <div className="flex flex-col gap-2 relative">
                            <div className="image-container relative">
                              <img
                                src={storeData.storeImage}
                                alt="Store Image"
                                style={{ width: "70px", height: "100px", margin: "5px" }}
                                onChange={(e) => setStoreImage({ ...storeData, storeImage: e.target.value })}

                              />
                            </div>
                          </div>
                        )}

                        <label htmlFor="cate_img" style={{ display: "flex", alignItems: "center" }}>
                          <img
                            className="rounded-md"
                            style={{
                              width: "100px",
                              height: "40px",
                              objectFit: "contain",
                              cursor: "pointer",
                              borderRadius: "5px",
                            }}
                            src={placeholder}
                            alt="tempImage"
                          />
                          <input
                            type="file"
                            // onChange={handleImagePathAdd}
                            id="cate_img"
                            multiple
                            // accept="image/jpg,video/x-m4v,video/*"
                            className="hidden"
                          />
                        </label>
                      </div>
                    </div>

                    <br />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div style={{ textAlign: "center", color: "red" }}>
            <span
              className="bg-red-700 rounded-md w-[10vw] cursor-pointer
             p-2 border-none outline-none ml-[1vw] text-white  text-sm"
              onClick={handleSubmit}
            >
              Submit
            </span>
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditShop;
